import { render, staticRenderFns } from "./HasDwellings.vue?vue&type=template&id=96d32f3c&"
import script from "./HasDwellings.vue?vue&type=script&lang=ts&"
export * from "./HasDwellings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports